import logger from '../utils/logger';
import React, { createContext, useContext, useState, useEffect } from 'react';

const PerformanceContext = createContext();

export const usePerformance = () => {
  const context = useContext(PerformanceContext);
  if (!context) {
    throw new Error('usePerformance must be used within a PerformanceProvider');
  }
  return context;
};

export const PerformanceProvider = ({ children }) => {
  // Load settings from localStorage or use defaults
  const [settings, setSettings] = useState(() => {
    const saved = localStorage.getItem('performanceSettings');
    return saved ? JSON.parse(saved) : {
      enableAnimations: true,
      enableGlowEffects: true,
      reduceMotion: false,
      enableTransitions: true,
      performanceMode: 'balanced' // 'performance', 'balanced', 'quality'
    };
  });

  // Save settings to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('performanceSettings', JSON.stringify(settings));
  }, [settings]);

  const updateSetting = (key, value) => {
    setSettings(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const setPerformanceMode = (mode) => {
    let newSettings = {};
    
    switch(mode) {
      case 'performance':
        newSettings = {
          enableAnimations: false,
          enableGlowEffects: false,
          reduceMotion: true,
          enableTransitions: false,
          performanceMode: 'performance'
        };
        break;
      case 'balanced':
        newSettings = {
          enableAnimations: true,
          enableGlowEffects: true,
          reduceMotion: false,
          enableTransitions: true,
          performanceMode: 'balanced'
        };
        break;
      case 'quality':
        newSettings = {
          enableAnimations: true,
          enableGlowEffects: true,
          reduceMotion: false,
          enableTransitions: true,
          performanceMode: 'quality'
        };
        break;
      default:
        return;
    }
    
    setSettings(newSettings);
  };

  const value = {
    settings,
    updateSetting,
    setPerformanceMode
  };

  return (
    <PerformanceContext.Provider value={value}>
      {children}
    </PerformanceContext.Provider>
  );
};

export default PerformanceContext;